var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.list.length != 0 ? _c("div", [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("模版预览")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-icon", {
    staticClass: "icon",
    style: _vm.pageIndex == 0 ? "color:#eee" : "",
    attrs: {
      type: "left"
    },
    on: {
      click: _vm.previousFun
    }
  }), _c("div", {
    staticClass: "phoneBox"
  }, [_vm.src ? _c("iframe", {
    attrs: {
      src: _vm.src,
      width: "100%",
      height: "100%",
      title: "Preview"
    }
  }) : _vm._e()]), _c("a-icon", {
    staticClass: "icon",
    style: _vm.disableColor ? "color:#eee" : "",
    attrs: {
      type: "right"
    },
    on: {
      click: _vm.nextFun
    }
  })], 1), _c("div", {
    staticClass: "name name2"
  }, [_vm._v(_vm._s(_vm.$t(_vm.list[_vm.pageIndex].controlsGroupPageTypeName)))])]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };